import React from 'react';
import PropTypes from 'prop-types';

export default class ExternalScript extends React.PureComponent {
  static ID_NAMESPACE = 'external-';

  constructor(props) {
    super(props);
  }

  componentDidMount() {
    const {delay} = this.props;

    if (process.env.SERVER) {
      return;
    }

    if (delay) {
      this.timer = setTimeout(this.injectScript, delay);
    } else {
      this.injectScript();
    }
  }

  componentWillUnmount() {
    if (this.timer) {
      clearTimeout(this.timer);
    }
  }

  injectScript = () => {
    const { src, children, id, uid } = this.props;

    if (this.isLoaded()) {
      return;
    }

    const script = document.createElement('script');

    if (id) {
      script.id = id;
    }

    if (uid) {
      script.id = ExternalScript.ID_NAMESPACE + uid;
    }

    if (children) {
      script.text = children;
    } else {
      script.src = src;
    }

    script.addEventListener('load', this.onLoad);
    script.addEventListener('error', this.onError);

    document.head.appendChild(script);
  };

  isLoaded = () => {
    const { id, uid, src } = this.props;

    if (id) {
      return !!document.getElementById(id);
    }

    if (uid) {
      return !!document.getElementById(ExternalScript.ID_NAMESPACE + uid);
    }

    return document.querySelector(`script[src="${src}"]`);
  };

  onLoad = () => {
    this.props.onLoad && this.props.onLoad();
  };

  onError = () => {
    this.props.onError && this.props.onError();
  };

  render() {
    return null;
  }
}

ExternalScript.propTypes = {
  uid: PropTypes.string,
  id: PropTypes.string,
  src: PropTypes.string,
  delay: PropTypes.number,
  children: PropTypes.string,
  onLoad: PropTypes.func,
  onError: PropTypes.func
};



// WEBPACK FOOTER //
// ./components/externalScript/ExternalScript.js